import { post } from "./AwsRequestService";

const myApi = 'FlightService'

export async function getFunFlight(requestBody) {
    const getPath = `/api/funflight`
    return await post(myApi, getPath, requestBody);
}